// Lead Contact card — start an org form prefilled from lead customer fields.
// When the lead already has a linked opportunity, anchor the form instance
// on the opportunity (deal-thread v1 — turbo_sales.md §3.8).

import { useEffect, useState } from "react";
import type { Lead } from "@/types/lead";
import { hasLeadUuidId } from "@/lib/lead/locationScope";
import { getLinkedOpportunityIdForLead } from "@/lib/opportunity/opportunityClient";
import { OrgFormStartAction } from "@/components/opportunity/OrgFormStartAction";

export function ContactCardFormAction(props: {
  lead: Lead;
  setToast: (t: { message: string; type: "success" | "error" } | null) => void;
}) {
  const { lead, setToast } = props;
  const [linkedOpportunityId, setLinkedOpportunityId] = useState<string | null>(
    () => lead.linked_opportunity_id ?? null,
  );

  useEffect(() => {
    const cached = lead.linked_opportunity_id ?? null;
    if (cached) {
      setLinkedOpportunityId(cached);
      return;
    }
    if (!hasLeadUuidId(lead)) return;
    let cancelled = false;
    void getLinkedOpportunityIdForLead(lead.id).then((r) => {
      if (cancelled || !r.ok || !r.data.opportunity_id) return;
      setLinkedOpportunityId(r.data.opportunity_id);
    });
    return () => {
      cancelled = true;
    };
  }, [lead.id, lead.linked_opportunity_id]);

  if (!hasLeadUuidId(lead)) return null;

  if (linkedOpportunityId) {
    return (
      <OrgFormStartAction
        compact
        sourceType="opportunity"
        leadId={lead.id}
        opportunityId={linkedOpportunityId}
        setToast={setToast}
      />
    );
  }

  return (
    <OrgFormStartAction compact sourceType="lead" leadId={lead.id} setToast={setToast} />
  );
}
